import 'bootstrap/dist/css/bootstrap.min.css'
import React, { useEffect, useState } from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import './App.css'
import Layout from './components/Layout/Layout'
import OrderForm from './components/OrderForm/OrderForm'
import RentOrderForm from './components/RentOrderForm/RentOrderForm'
import AboutUs from './components/ShowAboutUs/AboutUs'
import FAQContent from './components/ShowFaqContent/FAQContent'
import AllReports from './containers/AllReports/AllReports'
import Bunches from './containers/Bunches/Bunches'
import CalendarZones from './containers/CalendarZones/CalendarZones'
import ComplementaryReports from './containers/ComplementaryReports/ComplementaryReports'
import Contents from './containers/Contents/Contents'
import CourierRequestLogs from './containers/CourierRequestLogs/CourierRequestLogs'
import ElockChanges from './containers/ElockChanges/ElockChanges'
import Invoices from './containers/Invoices/Invoices'
import KioskDetails from './containers/KioskDetails/KioskDetails'
import KioskShifts from './containers/KioskShifts/KioskShifts'
import KioskTypes from './containers/KioskTypes/KioskTypes'
import KioskUnits from './containers/KioskUnits/KioskUnits'
import Kiosks from './containers/Kiosks/Kiosks'
import LockerTypes from './containers/LockerTypes/LockerTypes'
import Login from './containers/Login/Login'
import MainContent from './containers/MainContent/MainContent'
import MyOrders from './containers/MyOrders/MyOrders'
import MyProfile from './containers/MyProfile/MyProfile'
import Orders from './containers/Orders/Orders'
import ChangeOrderInterval from './containers/ChangeOrderInterval/ChangeOrderInterval'
import OrdersForEvacuation from './containers/OrdersForEvacuation/OrdersForEvacuation'
import Reports from './containers/Reports/Reports'
import Shifts from './containers/Shifts/Shifts'
import SystemPolicies from './containers/SystemPolicies/SystemPolicies'
import TariffCancelValues from './containers/TariffCancelValues/TariffCancelValues'
import TariffShiftValues from './containers/TariffShiftValues/TariffShiftValues'
import Tariffs from './containers/Tariffs/Tariffs'
import Units from './containers/Units/Units'
import Users from './containers/Users/Users'
import Videos from './containers/Videos/Videos'
import Zones from './containers/Zones/Zones'
import UnitKiosks from './containers/UnitKiosks/UnitKiosks'
import Generation2Lockers from './containers/Generation2Lockers/Generation2Lockers'
import KioskOrderDetails from './containers/KioskOrderDetails.js/KioskOrderDetails'
import UnitFranchiseKiosks from './containers/UnitFranchiseKiosks/UnitFranchiseKiosks'
import FranchiseOrders from './containers/FranchiseOrders/FranchiseOrders'
import Events from './containers/Events/Events'
import EventListeners from './containers/EventListeners/EventListeners'
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import UnitPickupAddresses from './containers/UnitPickupAdresses/UnitPickupAddresses'

const App = () => {
    const [token, setToken] = useState('');
    const [customer, setCustomer] = useState(false);
    const setTokenApp = (token) => {
        setToken(token);
    }
    useEffect(() => {
        if (!!window.localStorage && window.localStorage.getItem("token")) {
            var minutes = '';
            if (window.localStorage.getItem('expiration') != null && window.localStorage.getItem('expiration') != 'undefined' && window.localStorage.getItem('expiration') != '') {
                var expireDate = window.localStorage.getItem('expiration').split('_')
                var today = new Date();
                var time = expireDate[1].split('-')
                var times = time[0] + ':' + time[1]
                var expire = new Date(expireDate[0] + ' ' + times);
                var diff = Math.abs(expire - today) / 1000
                minutes = Math.floor(diff / 60)
            }
            if (minutes < 11) {
                window.localStorage.setItem("token", '')
            }
            const prmsn = window.localStorage.getItem("permission");
            if (prmsn.split(",").includes("CUSTOMER_WRITE")) {
                setCustomer(true);
            }
            if (window.localStorage.getItem("token")) {
                for (let key in window.localStorage) {
                    if (key == 'token') {
                        setToken(window.localStorage.getItem(key))
                    }
                    window.localStorage.setItem(key, window.localStorage.getItem(key));
                    window.localStorage.setItem(key, window.localStorage.getItem(key));
                }
            }
        }
    }, [!!window.localStorage && window.localStorage.getItem("token")]);

    return (
        <>
            <ToastContainer
                position="bottom-right"
                style={{ zIndex: 999999 }}
                autoClose={3000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={true}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                closeButton={false}
                theme="colored"
            />
            {!!window.localStorage && window.localStorage.getItem("token") != null && window.localStorage.getItem("token") != '' ?
                <Layout>
                    <Switch>
                        <Route path="/" exact component={customer ? MyOrders : MainContent} />
                        <Route path="/orders" component={Orders} />
                        <Route path="/change-order-interval" component={ChangeOrderInterval} />
                        <Route path="/evc-orders" component={OrdersForEvacuation} />
                        <Route path="/reports" component={Reports} />
                        <Route path="/all-reports" component={AllReports} />
                        <Route path="/clmnt-reports" component={ComplementaryReports} />
                        <Route path="/register-order" component={OrderForm} />
                        <Route path="/register-rent-order" component={RentOrderForm} />
                        <Route path="/locker-types" component={LockerTypes} />
                        <Route path="/kiosk-types" component={KioskTypes} />
                        <Route path="/kiosks" component={Kiosks} />
                        <Route path="/zones" component={Zones} />
                        <Route path="/contents" component={Contents} />
                        <Route path="/users" component={Users} />
                        <Route path="/units" component={Units} />
                        <Route path="/kiosks-details" component={KioskDetails} />
                        <Route path="/shifts" component={Shifts} />
                        <Route path="/tariffs" component={Tariffs} />
                        <Route path="/tariff-values" component={TariffShiftValues} />
                        <Route path="/tariff-cancels" component={TariffCancelValues} />
                        <Route path="/calendar-zones" component={CalendarZones} />
                        <Route path="/my-orders" component={MyOrders} />
                        <Route path="/my-profile" component={MyProfile} />
                        <Route path="/about-us" component={AboutUs} />
                        <Route path="/faq-content" component={FAQContent} />
                        <Route path="/invoices" component={Invoices} />
                        <Route path="/system-policies" component={SystemPolicies} />
                        <Route path="/bunches" component={Bunches} />
                        <Route path="/client-videos" component={Videos} />
                        <Route path="/shift-kiosk" component={KioskShifts} />
                        <Route path="/elock-changes" component={ElockChanges} />
                        <Route path="/kiosk-units" component={KioskUnits} />
                        <Route path="/unit-kiosks" component={UnitKiosks} />
                        <Route path="/unit-pickup-addresses" component={UnitPickupAddresses} />
                        <Route path="/logs" component={CourierRequestLogs} />
                        <Route path="/gnr2" component={Generation2Lockers} />
                        <Route path="/kiosk-order-details" component={KioskOrderDetails} />
                        <Route path="/unit-franchises" component={UnitFranchiseKiosks} />
                        <Route path="/my-franchise-orders" component={FranchiseOrders} />
                        <Route path="/event-list" component={Events} />
                        <Route path="/event-listeners" component={EventListeners} />
                    </Switch>
                </Layout >
                :
                <Switch>
                    <Route path="/" component={Login} />
                </Switch>
            }
        </>
    )
}

export default withRouter(App);
